import { Grid, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { EditImagingResults } from './EditImagingResults';
import { SectionHeader } from './SectionHeader';
import EditIcon from '@mui/icons-material/Edit';

export function ImagingResults({ test }) {
  const [neurologicalExamination, setNeurologicalExamination] = useState(test.neurologicalExamination);
  const [editMode, setEditMode] = useState(false);
  const isAdmin = useSelector((state) => state.GlobalReducer.loggedUser?.adminRole === 'ADMIN');

  const showHemorrhagicData = () => {
    let diagnosis = 'NONE';
    if (neurologicalExamination?.hemorrhagic) {
      diagnosis = neurologicalExamination.hemorrhagic.side;
      if (neurologicalExamination.hemorrhagic.cortical) {
        diagnosis = diagnosis + ' - Cortical  (' + neurologicalExamination.hemorrhagic.cortical.join(',') + ')';
      }
      if (neurologicalExamination.hemorrhagic.subcortical) {
        diagnosis = diagnosis + ' - Subcortical  (' + neurologicalExamination.hemorrhagic.subcortical.join(',') + ')';
      }
    }
    return diagnosis;
  };

  const showIschemicData = () => {
    let diagnosis = 'NONE';
    if (neurologicalExamination?.ischemic) {
      diagnosis = neurologicalExamination.ischemic.side;
      if (neurologicalExamination.ischemic.cortical) {
        diagnosis = diagnosis + ' - Cortical  (' + neurologicalExamination.ischemic.cortical.join(',') + ')';
      }
      if (neurologicalExamination.ischemic.subcortical) {
        diagnosis = diagnosis + ' - Subcortical  (' + neurologicalExamination.ischemic.subcortical.join(',') + ')';
      }
    }
    return diagnosis;
  };

  const showBooleanValue = (value) => {
    if (value === null) return 'N/A';

    return value ? 'Yes' : 'No';
  };

  const saveHandler = (val) => {
    setNeurologicalExamination(val);
    setEditMode(false);
  };

  return (
    <>
      {!editMode ? (
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12}>
            <Stack direction="row">
              <SectionHeader name="Imaging Results" />
              {isAdmin ? (
                <IconButton
                  onClick={() => {
                    setEditMode(true);
                  }}
                >
                  <EditIcon />
                </IconButton>
              ) : (
                ''
              )}
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Typography>Ischemic</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography sx={{ textAlign: 'right' }}>{showIschemicData()}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>Thrombolytic given</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography sx={{ textAlign: 'right' }}>{showBooleanValue(neurologicalExamination?.thrombolyticGiven)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>Hemorrhagic</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography sx={{ textAlign: 'right' }}>{showHemorrhagicData()}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>LVO</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography sx={{ textAlign: 'right' }}>{showBooleanValue(neurologicalExamination?.lvo)}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography>Thrombectomy Performed</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography sx={{ textAlign: 'right' }}>{showBooleanValue(neurologicalExamination?.thrombectomyPerformed)}</Typography>
          </Grid>
        </Grid>
      ) : (
        <EditImagingResults testId={test.uuid} neurologicalExamination={neurologicalExamination} onCancel={() => setEditMode(false)} onSaved={saveHandler} />
      )}
    </>
  );
}
